import React from "react";

/** Shared tone vocabulary for dashboard status surfaces (badge + banner). */
export type DashboardStatusTone = "neutral" | "info" | "warning" | "error";

const PILL_TONE: Record<DashboardStatusTone, string> = {
  neutral: "bg-slate-100 text-slate-700",
  info: "bg-blue-100 text-blue-700",
  warning: "bg-amber-100 text-amber-700",
  error: "bg-rose-100 text-rose-700",
};

interface IProps {
  label: string;
  tone?: DashboardStatusTone;
}

/**
 * Small rounded status pill (e.g. "Data may be stale", "Estimated"). Consolidates the
 * one-off inline pills that were hand-rolled across the dashboard surfaces.
 */
export const DashboardStatusBadge = (props: IProps) => (
  <span
    className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${
      PILL_TONE[props.tone ?? "neutral"]
    }`}
  >
    {props.label}
  </span>
);
